import {
  APIError,
  type ConversationGetInput,
  type ConversationGetSuccess,
  type NotificationDestinationTarget,
} from '@terros/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { conversationKey } from '../conversation/keys'
import { useServerRequest } from '../api'

type NotificationDestinationResolver = {
  resolve: (destination: NotificationDestinationTarget | null) => Promise<NotificationDestinationTarget | null>
  isResolving: boolean
}

export function useNotificationDestination(): NotificationDestinationResolver {
  const getConversation = useServerRequest<ConversationGetInput, ConversationGetSuccess>('/conversation/get')
  const client = useQueryClient()
  const mutation = useMutation({
    mutationFn: async (
      destination: NotificationDestinationTarget | null
    ): Promise<NotificationDestinationTarget | null> => {
      if (destination?.kind !== 'conversation') return destination
      try {
        const { conversation } = await getConversation({ conversationId: destination.convoId })
        client.setQueryData(conversationKey(conversation.convoId), conversation)
        return destination
      } catch (error) {
        const unavailable = error instanceof APIError && ['NotAuthorized', 'NotFound'].includes(error.error.error)
        if (unavailable) return { kind: 'notifications' }
        throw error
      }
    },
  })
  return { resolve: mutation.mutateAsync, isResolving: mutation.isPending }
}
